module.exports = __webpack_public_path__ + "static/img/timg4.4ca9c9a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/timg4.jpeg
// module id = rKXe
// module chunks = 8